module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "align-center": "",
      "py-3": "",
      "pl-3": ""
    }
  }, _vm._l((_vm.cards), function(card, i) {
    return _c('v-flex', {
      key: i,
      staticClass: "card-box mr-3"
    }, [_c('policy-card', {
      class: {
        active: _vm.selected.indexOf(i) != -1
      },
      attrs: {
        "policy": card,
        "value": _vm.flipped
      },
      on: {
        "input": function($event) {
          _vm.onClick(i)
        }
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27e4376e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/LEGISLATING/policy-selector.vue
// module id = 316
// module chunks = 0